import React from 'react';

interface PayoffHowToSectionProps {
  value?: string;
}

const PayoffHowToSection: React.FC<PayoffHowToSectionProps> = ({ value }) => {
  const videoWidth = 480; // set your desired video width

  return (
    <div style={{ textAlign: 'center', margin: '20px' }}>
      {value ? <h1>{value} How to Use Debt Payoff Tracker</h1> : <h1>How to Use Debt Payoff Tracker</h1>}

      {/* Container for the list with constrained width */}
      <div style={{ width: videoWidth, margin: '0 auto', textAlign: 'left' }}>
        <ol style={{ lineHeight: '1.6', padding: '0 20px' }}>
          <li>Watch this video.</li>
          <li>
            Once you watch this video, please look around and click{' '}
            <strong>remove example payoff data</strong> when you’re ready to add your own data.
          </li>
          <li>
            Please email us at{' '}
            <a href="mailto:support-team@tryascend.com">support-team@tryascend.com</a> with any questions.
          </li>
        </ol>
      </div>

      {/* Container for the video with the same width */}
      <div style={{ marginTop: '20px', marginBottom: '-30px', width: videoWidth, marginLeft: 'auto', marginRight: 'auto' }}>
        <iframe
          width={videoWidth}
          height="270"
          src="https://www.youtube.com/embed/RR-kSVP-Dr8"
          title="How to Use Spending Tracker"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ maxWidth: '100%' }}
        />
      </div>
    </div>
  );
};

export default PayoffHowToSection;